import { generateClient } from "aws-amplify/api";
import * as mutations from "../graphql/mutations";
import * as queries from "../graphql/queries";

import { REST_API_URL, REST_GET_COUNTRY_PATH } from "../constants";

const client = generateClient();

class API {
  constructor() {}

  checkUser(email, phone, provider, providerUserId) {
    return new Promise(function (resolve, reject) {
      client
        .graphql({
          query: queries.LS_checkUser,
          variables: { email, phone, provider, providerUserId },
          authMode: "iam",
        })
        .then((data) => {
          resolve(JSON.parse(data.data.LS_checkUser));
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  getCountry() {
    return new Promise(function (resolve, reject) {
      fetch(`${REST_API_URL}${REST_GET_COUNTRY_PATH}`, {
        method: "GET",
      })
        .then((res) => res.json())
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  createUser(email, name, phone, birthdate, gender, provider, providerUserId) {
    return new Promise(function (resolve, reject) {
      client
        .graphql({
          query: mutations.LS_createUser,
          variables: {
            email,
            name,
            phone,
            birthdate,
            gender,
            provider,
            providerUserId,
          },
          authMode: "iam",
        })
        .then((data) => {
          resolve(JSON.parse(data.data.LS_createUser));
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  disableUser(username, reason, message) {
    return new Promise(function (resolve, reject) {
      client
        .graphql({
          query: mutations.LS_disableUser,
          variables: { username, reason, message },
        })
        .then((data) => {
          resolve(JSON.parse(data.data.LS_disableUser));
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  syncUser(username) {
    return new Promise(function (resolve, reject) {
      client
        .graphql({
          query: mutations.LS_syncUser,
          variables: { username },
        })
        .then((data) => {
          resolve(JSON.parse(data.data.LS_syncUser));
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  sendPhoneAuthCode(phone, countryCode) {
    return new Promise(function (resolve, reject) {
      client
        .graphql({
          query: mutations.LS_sendPhoneAuthCode,
          variables: { phone, countryCode },
          authMode: "iam",
        })
        .then((data) => {
          resolve(data.data.LS_sendPhoneAuthCode);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  confirmPhoneAuthCode(code, phone, countryCode) {
    return new Promise(function (resolve, reject) {
      client
        .graphql({
          query: mutations.LS_confirmPhoneAuthCode,
          variables: { code, phone, countryCode },
          authMode: "iam",
        })
        .then((data) => {
          resolve(data.data.LS_confirmPhoneAuthCode);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  updatePhoneNumber(username, phone) {
    return new Promise(function (resolve, reject) {
      client
        .graphql({
          query: mutations.LS_updatePhoneNumber,
          variables: { username, phone },
          authMode: "iam",
        })
        .then((data) => {
          resolve(data.data.LS_updatePhoneNumber);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  updatePassword(username, password) {
    return new Promise(function (resolve, reject) {
      client
        .graphql({
          query: mutations.LS_updatePassword,
          variables: { username, password },
          authMode: "iam",
        })
        .then((data) => {
          resolve(data.data.LS_updatePassword);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  getUserInfo(username) {
    return new Promise(function (resolve, reject) {
      client
        .graphql({
          query: queries.LS_getUserInfo,
          variables: { username },
        })
        .then((data) => {
          resolve(JSON.parse(data.data.LS_getUserInfo));
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  getUserStatus(email) {
    return new Promise(function (resolve, reject) {
      client
        .graphql({
          query: queries.LS_getUserStatus,
          variables: { email },
          authMode: "iam",
        })
        .then((data) => {
          resolve(data.data.LS_getUserStatus);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}

const instance = new API();
export default instance;
